import { render } from "./PacienteForm.vue?vue&type=template&id=3a9fa6b2"
import script from "./PacienteForm.vue?vue&type=script&lang=js"
export * from "./PacienteForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__